import login from './login'
import giftCode from './giftCode'

export default {
  // import file language
  // ...user
  ...login,
  ...giftCode
}
